import GVTextField, { GVTextFieldProps } from 'components/lib/GVTextField/GVTextField';
import { useField, useFormikContext } from 'formik';
import React, { useEffect } from 'react';
import { useQuery } from '@redux-requests/react';
import { fetchActiveUserOrganization } from 'store/myAccount/requests';

interface LinkedTextFieldProps extends GVTextFieldProps {
  name: string;
  linkedfieldvalue: string;
}

const LinkedTextField = ({ name, linkedfieldvalue, ...textFieldProps }: LinkedTextFieldProps) => {
  const { setFieldValue, getFieldMeta } = useFormikContext();
  const { data: organizationData } = useQuery({ type: fetchActiveUserOrganization });
  const meta = getFieldMeta(name);
  const [field] = useField(name);
  const [isLinked, setIsLinked] = React.useState(true);

  useEffect(() => {
    if (
      organizationData?.connection &&
      organizationData?.connection.signInURL !== organizationData?.connection.signOutURL
    ) {
      // if the values are offset initially, we need to unlink the input
      setIsLinked(false);
    }
  }, [organizationData]);

  const handleChange = (value: string | null) => {
    setIsLinked(false);
    setFieldValue(name, value ?? '');
  };

  React.useEffect(() => {
    if (
      isLinked &&
      // we check that the field value is not updated on mount so that the form is not validated on form mount
      !(linkedfieldvalue === '' && field.value === '')
    ) {
      setFieldValue(name, linkedfieldvalue);
    }
  }, [linkedfieldvalue]);

  const message = typeof meta.error === 'string' ? meta.error : undefined;

  return (
    <GVTextField
      {...textFieldProps}
      name={name}
      value={field.value}
      onValueChange={handleChange}
      hasError={Boolean(meta.error)}
      message={message}
    />
  );
};

export default LinkedTextField;
